import { classNames } from "../../utils/helpers";

export function Chip({ active, children, onClick, isRetailerMobile = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition-all duration-300",

        // 🔵 Retailer Mobile Theme
        isRetailerMobile
          ? active
            ? "bg-blue-600 backdrop-blur-xl border border-white/40 text-white shadow-md"
            : "bg-white/10 backdrop-blur-xl border border-white/20 text-slate-800 hover:bg-white/20"
          
          // 💻 Default Desktop Theme
          : active
          ? "bg-blue-600 text-white"
          : "bg-blue-50 text-blue-700 hover:bg-blue-100"
      )}
    >
      {children}
    </button>
  );
}


// import { classNames } from "../../utils/helpers";

// export function Chip({ active, children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className={classNames(
//         "whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition",
//         active ? "bg-blue-600 text-white" : "bg-blue-50 text-blue-700 hover:bg-blue-100"
//       )}
//     >
//       {children}
//     </button>
//   );
// }